<template>
  <div class="health_group">
    <van-nav-bar title="群体生产指标" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="群体生产指标" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="swine_wrap"> 
        <van-row>
            <van-collapse v-model="activeNames">
                <van-collapse-item title="1、种猪场基础母猪规模（头）" name="1">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                    <th></th>
                                    <th>大型种猪场</th>
                                    <th>中型种猪场</th>
                                    <th>小型种猪场</th>
                                </tr>
                                <tr>
                                    <td>选育场</td>
                                    <td>>600</td>
                                    <td>400-600</td>
                                    <td>300-400</td>
                                </tr>
                                <tr>
                                    <td>扩繁场</td>
                                    <td>>1000</td>
                                    <td>600-1000</td>
                                    <td>300-600</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="2、猪群的饲养密度" name="2">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                
                                    <th colspan="2">猪群类别</th>
                                    <th colspan="1">每栏建议饲养头数（头）</th>
                                    <th colspan="1">每头占猪栏面积（m<sup class="up_hea">2</sup>）</th>
                                </tr>
                                <tr>
                                    <td colspan="2">种公猪</td>
                                    <td>1</td>
                                    <td>7.5~9.0</td>
                               
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="2" style="width:.5rem">空怀、妊娠母猪</td>
                                    <td>限位栏</td>
                                    <td>1</td>
                                    <td>1.3~1.5</td>
                             
                                </tr>
                                <tr>
                                    <td  colspan="1">群养</td>
                                    <td colspan="1">4~5</td>
                                    <td colspan="1">2.3~2.9</td>
                                </tr>
                                <tr>
                                    <td colspan="2">后备母猪</td>
                                    <td colspan="1">4~6</td>
                                    <td colspan="1">2.5~2.8</td>
                                </tr>
                                <tr>
                                    <td  colspan="2">生长猪</td>
                                    <td colspan="1">10</td>
                                    <td colspan="1">0.3~0.5</td>
                                </tr>
                                <tr>
                                    <td  colspan="2">育肥猪</td>
                                    <td colspan="1">8~12</td>
                                    <td colspan="1">0.5~0.8</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="3、猪场整体生产技术指标" name="3">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                    <th>指标名称</th>
                                    <th>指标数值</th>
                                </tr>
                                <tr>
                                    <td>基础母猪年出栏商品猪数/头</td>
                                    <td>≥20</td>
                                </tr>
                                <tr>
                                    <td>商品猪出栏率/%</td>
                                    <td>≥160></td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="4、母猪繁殖性能指标" name="4">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                    <th>指标名称</th>
                                    <th>指标数值</th>
                                </tr>
                                <tr>
                                    <td>基础母猪断奶后第一情期受胎率/%</td>
                                    <td>≥85</td>
                                </tr>
                                <tr>
                                    <td>分娩率/%</td>
                                    <td>≥96</td>
                                </tr>
                                <tr>
                                    <td>基础母猪年均产仔窝数/[窝/（年▪头）]</td>
                                    <td>≥2.1</td>
                                </tr>
                                <tr>
                                    <td>基础母猪平均每窝产活仔数/（头/窝）</td>
                                    <td>≥10.5</td>
                                </tr>
                                <tr>
                                    <td>断奶日龄/天</td>
                                    <td>≥28.0</td>
                                </tr>
                                <tr>
                                    <td>哺乳仔猪成活率/%</td>
                                    <td>≥92</td>
                                </tr>
                                <tr>
                                    <td>基础母猪年提供断奶仔猪数/（头/年）</td>
                                    <td>≥20</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                 <van-collapse-item title="5、猪生产技术指标" name="5">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                    <th>发情周期</th>
                                    <th>21d</th>
                                    <th>圈期成活率</th>
                                    <th>90%</th>
                                </tr>
                                <tr>
                                    <td>怀孕期</td>
                                    <td>114d</td>
                                    <td>配种分娩率</td>
                                    <td>85%</td>
                                </tr>
                                <tr>
                                    <td>哺乳期</td>
                                    <td>21~28d</td>
                                    <td>仔猪初生重</td>
                                    <td>1.2~1.4kg</td>
                                </tr>
                                <tr>
                                    <td>断奶至下次发情</td>
                                    <td>3~10d</td>
                                    <td>21日龄个体重</td>
                                    <td>6kg</td>
                                </tr>
                                <tr>
                                    <td>母猪年产胎次</td>
                                    <td>2.2胎</td>
                                    <td>28日龄个体重</td>
                                    <td>7.5~8kg</td>
                                </tr>
                                
                                <tr>
                                    <td>经产母猪窝产活仔数</td>
                                    <td>10头</td>
                                    <td>8周龄个体重</td>
                                    <td>18kg</td>
                                </tr>
                                <tr>
                                    <td>初产母猪窝产活仔数</td>
                                    <td>8.5</td>
                                    <td>24周龄个体重</td>
                                    <td>93~100kg</td>
                                </tr>
                                <tr>
                                    <td>哺乳仔猪的成活率</td>
                                    <td>92%</td>
                                    <td>母猪使用年限</td>
                                    <td>3年（6~8胎）</td>
                                </tr>
                                <tr>
                                    <td>保育猪的成活率</td>
                                    <td>96%</td>
                                    <td>公母比例</td>
                                    <td>1:25</td>
                                </tr>
                                <tr>
                                    <td>生长育肥猪成活率</td>
                                    <td>98%</td>
                                    <td>公猪使用年限</td>
                                    <td>4年</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                 <van-collapse-item title="6、生长育肥期猪性能指标" name="6">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                    <th colspan="2">指标名称</th>
                                    <th colspan="1">指标数值</th>
                                </tr>
                                <tr>
                                    <td  colspan="2">仔猪平均断奶体重（4周龄）/（kg/头）</td>
                                    <td colspan="1">≥7.0</td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="3">仔猪保育期（5周龄~10周龄）</td>
                                    <td colspan="1">期末体重/（kg/头）</td>
                                    <td colspan="1">≥20.0</td>
                                </tr>
                                <tr>
                                    <td colspan="1">料重比/（kg/kg）</td>
                                    <td colspan="1">≤1.8</td>
                                </tr>
                                <tr>
                                    <td colspan="1">成活率/%</td>
                                    <td colspan="1">≥95</td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="3">生长育肥期（11周龄~25周龄）</td>
                                    <td colspan="1">成活率/%</td>
                                    <td colspan="1">≥98</td>
                                </tr>
                                <tr>
                                    <td colspan="1">日增重/（g/d）</td>
                                    <td colspan="1">≥650</td>
                                </tr>
                                <tr>
                                    <td colspan="1">料重比/（kg/kg）</td>
                                    <td colspan="1">≤3.0</td>
                                </tr>
                                <tr>
                                    <td colspan="1">170日龄体重/（kg/头）</td>
                                    <td colspan="1"></td>
                                    <td colspan="1">≥90</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
            </van-collapse>
            
        </van-row>
        
      
    </div>
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/top.vue'
import { labbiosafetyeval } from '@/api/resetApi.js'

export default {
  name: 'health_group',
  components: {
    Top
  },
  data(){
    return{
        activeNames: ['1'],
        grade_num: '',
        eval_result: '',
        browser: {
            trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
            presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
            webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
            mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
            ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
            webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
        },
        goodsList: [],
        btnFlag:false,
        isWx:1,
    };
  },
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    async labbiosafetyeval() {
      let qs = require('qs');
      let data = qs.stringify(JSON.parse(this.laboratorylist))
      const res = await labbiosafetyeval(data)
      console.log(res)
      try {
        if (res.data.code === 1) {
          this.grade_num = res.data.grade_num
          if (res.grade_num>=76) {
            this.eval_result = res.data.eval_result+',继续保持哦～'
          } else{
            this.eval_result = res.data.eval_result+',待整改完善'
          }
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    retest() {
      this.$store.state.report.laboratorydata = []
      this.$router.back(-1)
    },
    laboratorys() {
      if (this.browser.android) {
        ZKAPP.laboratory();
      }else {
        window.webkit.messageHandlers.laboratory.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<style lang="scss">
.health_group{
    .van-cell__title{
        text-align: left;
        span{
            // font-weight: bold;
            font-size: 16px;
        }
    }
    .up_hea{
        vertical-align:super;
    }
    .health_tab{
        width:100%;
        
        border-collapse:collapse;
        tr td{
            border:1px  solid #CCCCCC;
            padding: .05rem;
            text-align: center;
                color: #4C4C4C;
        }
        th{
            border:1px  solid #CCCCCC;
            padding: .05rem;
            font-size: 14px;
            text-align: center;
                color: #4C4C4C;
        }
    }
    .van-collapse-item__content{
        background:#F5F5F5 ;
    }
    .van-nav-bar .van-icon{
        color: #999999;
    }
    .swine_wrap{
        font-size: 14px;
    }
    .health_group_title{
        padding: .2rem;
        background: #F6F9FF;
        text-align: left;
        font-weight: bold;
        font-size: 16px;
    }
    .health_group_card{
        padding: .2rem;
        .van-col {
            margin-bottom: 10px;
            
            font-size: 14px;
            line-height: 50px;
            text-align: center;
            background-clip: content-box;
            color: #4C4C4C;
            border: 1px solid #F5F5F5;
            padding: 0!important;
            width: 30%;
            margin: 5px;
        }
    }
    .health_group_icon{
        // padding: .2rem;
            // background-color: #66c6f2;
        // border: 1px solid #F5F5F5;
    }
    
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
.res2{
  width: 200px;
  height: 200px;
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
  color:#fff;
}
.res{
  width: 200px;
  height: 200px;
  background: url(../../assets/subjectimg/t1.png) top center no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
  color:#fff;

}
.res1{
  width: 200px;
  height: 200px;
  background: url(../../assets/subjectimg/b1.png) top center no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
}
.branch{
  font-size: 70px;
}
.branch1{
  font-size: 24px;
}
img{
  display: inline-block;
  vertical-align: middle;
}
.res_text{
  padding: 60px 0;
  font-size: 0;
  text-align: center;
}
.res_text span{
  margin-left: 10px;
  vertical-align: middle;
  font-size: 20px;
  color: #4A4A4A;
}
.res_text img{
  width: 30px;
  height: 30px;
}
.btn_bottom {
  font-size: 0;
}
</style>
